<template>
    <div class="category-page">
        <h1>Liste de questions :</h1>

        <div class="btn-add-question">
            <span class="material-symbols-outlined" @click="toggleAddQuestionModale">add_circle</span>
        </div>

        <modale :show="showAddQuestionModale" @toggle="toggleAddQuestionModale">
            <QuestionForm @closeForm="saveQuestion" />
        </modale>

        <table class="questions-list">
            <tr>
                <th>Question</th>
                <th>Difficulté</th>
                <th>Date de création</th>
                <th>Date de mise à jour</th>
                <th>Actions</th>
            </tr>

            <tr v-for="question in questions" :key="question._id">
                <td>{{ question.label }}</td>
                <td>{{ question.difficulty }}</td>
                <td>{{ dateToString(question.createdAt) }}</td>
                <td>{{ dateToString(question.updatedAt) }}</td>
                <td></td>
            </tr>
        </table>
    </div>
</template>

<script>
import axios from 'axios';
import QuestionForm from '../forms/Question.vue';

export default {
    components: {
        QuestionForm,
    },
    data() {
        return {
            questions: [],
            showAddQuestionModale: false,
        }
    },
    methods: {
        async getQuestions() {
            const result = await axios.get(this.$store.getters.get_api_url + 'academy/questions/' + this.$route.params.categoryId);
            this.questions = result.data;
        },
        toggleAddQuestionModale() {
            this.showAddQuestionModale = !this.showAddQuestionModale;
        },
        saveQuestion(newQuestion) {
            this.questions.push(newQuestion);
            this.showAddQuestionModale = false;
        }
    },
    watch: {
        '$route.params.categoryId': {
            immediate: true,
            handler() {
                this.getQuestions();
            }
        }
    },
}
</script>

<style scoped>
.category-page {
    position: relative;
    padding: 10px;
}

.btn-add-question {
    position: absolute;
    top: 20px;
    right: 20px;
}

.btn-add-question .material-symbols-outlined {
    cursor: pointer;
    font-size: 48px;
}

.btn-add-question .material-symbols-outlined:hover {
    color: #FB984B;
}

.category-page h1 {
    font-size: 28px;
}

table.questions-list {
    width: 100%;
}

table.questions-list th,
table.questions-list td {
    padding: 10px;
    font-size: 12px;
}

table.questions-list th {
    background-color: #0A1C6B;
    color: white;
}

table.questions-list td {
    background-color: white;
    text-align: center;
}

table.questions-list tr td:first-child {
    text-align: left;
}

table.questions-list tr:first-child th:first-child {
    border-top-left-radius: 10px;
}

table.questions-list tr:first-child th:last-child {
    border-top-right-radius: 10px;
}

table.questions-list tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
}

table.questions-list tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
}
</style>